import { styled } from '@mui/material/styles';
import { 
  Box, 
  Button, 
  Paper, 
  TextField, 
  Tab, 
  Tabs,
  Typography,
  Link
} from '@mui/material';

export const AuthRoot = styled(Box)(({ theme }) => ({
  height: '100vh',
  [theme.breakpoints.down('sm')]: {
    height: '100%',
    marginTop: 20,
  },
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignContent: 'center',
  backgroundColor: '#F9FBFF',
}));

export const FormPaper = styled(Paper)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.primary.contrastText,
  padding: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    padding: 20,
    height: '100%',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  margin: 'auto',
  maxWidth: 500,
  borderRadius: '16px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(2),
  '& img': {
    height: 64,
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  color: theme.palette.text.primary,
  margin: `${theme.spacing(2)} 0px`,
  alignSelf: 'center',
  '& .MuiInputBase-root': {
    height: 56,
    borderRadius: 8,
    fontSize: '1rem',
  },
  '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary[400],
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.1)',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary[400],
    borderWidth: 1,
  },
}));

export const TabContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '& .MuiTabs-indicator': {
    backgroundColor: 'transparent',
  },
}));

export const NavigationTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

export const StyledTab = styled(Tab)(({ theme }) => ({
  width: '50%',
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 500,
  color: theme.palette.text.primary,
  '&.Mui-selected': {
    color: theme.palette.text.primary,
    fontWeight: 600,
    backgroundColor: '#F5F6F8',
    borderRadius: 8,
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  alignSelf: 'center',
  margin: `${theme.spacing(3)} 0`,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  height: 48,
  fontSize: '1rem',
  borderRadius: '8px',
  width: '100%',
  fontWeight: 500,
  '& svg': {
    color: `${theme.palette.primary.contrastText}`,
  },
  '&:hover': {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.contrastText}`,
    '& svg': {
      color: `${theme.palette.text.secondary}`,
    },
  },
}));

export const OrDivider = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& hr': {
    flexGrow: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    height: 1,
  },
  '& p': {
    color: 'rgba(0, 0, 0, 0.5)',
    padding: '0 16px',
    fontSize: '0.9rem',
    margin: 0,
  },
}));

export const GoogleButton = styled(Button)(({ theme }) => ({
  boxShadow: 'none !important',
  border: '1px solid rgba(0, 0, 0, 0.1) !important',
  borderRadius: '8px !important',
  justifyContent: 'center',
  height: 48,
  backgroundColor: '#fff',
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(2),
  },
  '& .MuiTypography-root': {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
  },
  width: '100%',
  marginBottom: theme.spacing(3),
}));

export const TermsText = styled(Typography)(({ theme }) => ({
  // textAlign: 'center',
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '1rem',
  // marginTop: theme.spacing(3),
  
  '& a': {
    color: theme.palette.info[500],
    textDecoration: 'none',
    fontWeight: 500,
  },
}));

export const AuthTabsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  backgroundColor: '#F5F6F8',
  // borderRadius: 8,
  padding: 4,
  marginBottom: theme.spacing(3),
}));

export const AuthTab = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  flex: 1,
  textAlign: 'center',
  padding: theme.spacing(1.5),
  borderRadius: 0,
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  backgroundColor: active ? theme.palette.common.white : 'transparent',
}));

export const TabLabel = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    marginRight: 8,
  },
});

export const ForgotPasswordLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  fontWeight: 500,
  textAlign: 'right',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const formComponents = {
  AuthRoot,
  FormPaper,
  LogoContainer,
  StyledTextField,
  TabContainer,
  NavigationTabs,
  StyledTab,
  SubmitButton,
  OrDivider,
  GoogleButton,
  TermsText,
  AuthTabsContainer,
  AuthTab,
  TabLabel,
  ForgotPasswordLink
};

export default formComponents;